export default __webpack_public_path__ + "static/how-to-sell-your-car-for-the-best-price-dfede722590ca9894208f010df9cc94f.jpg";